<template><div><h1 id="lander" tabindex="-1"><a class="header-anchor" href="#lander"><span>Länder</span></a></h1>
<p>Länder — Definition gültiger Länder</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Hier werden die Länder definiert, die bei der Adresseingabe validiert werden. Grundlage ist die 2-stellige ISO-Norm der Ländernamen, wie sie beim Weltpostverband erhältlich ist. Die Tabelle wird von ARENAE aktualisiert und kann ggf. auch vom Kunden manuell ergänzt werden.</p>
<p>Pfad: <code v-pre>Datenaustausch → Tabellen → Postdaten → Länder</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Cd</dt>
<dd>ISO-Code für die Bezeichnung des Landes</dd>
<dt>Ländername</dt>
<dd>Deutsche Bezeichnung des Landes</dd>
<dt>Land-Adresszeile</dt>
<dd>Eintrag für Anschrift/Export bei ausländischen Sendungen</dd>
<dt>PLZ</dt>
<dd>vorne/hinten, Positione von PLZ und Ort. vorne = PLZ steht vor dem Ort, hinten = PLZ steht hinter dem Ort</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>Standardfunktionalität</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/manual/administration/postdaten_verarbeiten.html" title="5. Post-Daten verarbeiten">Postdaten verarbeiten</RouteLink></p>
</div></template>


